export default __webpack_public_path__ + "static/media/digital8.ef246dc0.jpg";